import { feathers } from '@/feathers-client';
import getCustomAudiencesError from '../config/facebook-errors';
import isEmpty from 'lodash/isEmpty'
import facebookSourceType from '../config/facebook-source-types';

export default {
  namespaced: true,
  state: {
    customAudiencesErrorDetails: {},
    customAudienceGeneralErrorMessage: null,
    showCustomAudiencesError: false,
    fbSelectedType: null,
  },
  mutations: {
    setCustomAudiencesErrorDetails(state, error) {
      state.customAudiencesErrorDetails = error;
    },
    setCustomAudienceGeneralErrorMessage(state, errorMessage) {
      state.customAudienceGeneralErrorMessage = errorMessage;
    },
    setShowCustomAudiencesError(state, activate) {
      state.showCustomAudiencesError = activate;
    },
    setFbSelectedType(state, fbType) {
      state.fbSelectedType = fbType;
    },
  },
  actions: {
    async createCustomAudience({ rootState, state, commit }, customAudience){
      const payload = Object.assign(customAudience);
      let response;
      try {
        response = await feathers.service('custom-audiences').create(payload);
        commit('contactsTable/setIsCustomAudienceCreated', true, {root: true});
      } catch ({ data, message }) {
        const { fbPersonalAdAccounts, fbLiondeskAdAccount } = rootState.facebookBusiness;
        let fb_ad_account_id = fbLiondeskAdAccount.fb_ad_account_id;
        if (state.fbSelectedType === facebookSourceType['fbPersonal'].type) {
          fb_ad_account_id = fbPersonalAdAccounts.find(account => 
            account.fb_ad_id === customAudience.fb_ad_id
          ).fb_ad_account_id;
        }
        commit('setCustomAudiencesErrorDetails', getCustomAudiencesError(
          data.error_subcode ? data.error_subcode : data.code,
          !!data.error_subcode,
          fb_ad_account_id)
        );
        isEmpty(state.customAudiencesErrorDetails) ?
          commit('setCustomAudienceGeneralErrorMessage', message) :
          commit('setShowCustomAudiencesError', true);
      }
    },
  },
};
